export default "__VITE_ASSET__6hqcxYmd__"